// extracted by mini-css-extract-plugin
module.exports = {"control":"control-track_control__SUpbt","btn":"control-track_btn__9wOsy","btnPrev":"control-track_btnPrev__qeGXI","playButtons":"control-track_playButtons__VmLZ1"};